import React from 'react';
import cn from 'classnames';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import Input from '@dealroadshow/uikit/core/components/Input';
import IconCategoriesEmpty from '@dealroadshow/uikit/core/components/Icon/IconCategoriesEmpty';
import FinalForm, { Field } from '@/Framework/UI/Organisms/FinalForm';
import { isScreenXs } from '@dealroadshow/uikit/core/styles/screen/screen';
import { usePortfoliosContext } from '@/finsight/application/PortfolioMonitor/PortfoliosContext';
import { useStepFormContext } from '@/finsight/application/PortfolioMonitor/StepFormContext';
import { useFormPayloadContext } from '@/finsight/application/PortfolioMonitor/FormPayloadContext';
import validate from './validate';

import portfolioStyles from '../../../portfolioContent.scss';
import styles from './namePortfolioForm.scss';

const NamePortfolioForm = () => {
  const {
    isLoading,
    portfolioCollection,
    selectedPortfolio,
  } = usePortfoliosContext();
  const { goNext } = useStepFormContext();
  const { setPayload, payload } = useFormPayloadContext();
  const continueButtonStyles = cn(styles.continueButton, {
    [styles.buttonFetching]: isLoading,
  });

  const renderFields = ({ hasValidationErrors, hasSubmitErrors, dirtySinceLastSubmit }) => (
    <>
      <Field
        name="portfolioName"
        label="NAME YOUR PORTFOLIO"
        component={ Input }
        placeholder={ isScreenXs() ? 'eg “Actively Managed Fund”' : 'eg “Actively Managed Fund” or “Watchlist”' }
        dataTest="portfolioNameInput"
      />
      <div className={ styles.explanationUsage }>
        For example, “Actively Managed” could be the name of your portfolio.
        Within the portfolio could be two lists, one titled “Auto” and another titled “CLO” or “Owned” and “Watchlist”.
        Within each list, are the securities you wish to track.
      </div>
      <div className={ styles.buttonWrapper }>
        <Button
          className={ continueButtonStyles }
          disabled={ isLoading || hasValidationErrors || (hasSubmitErrors && !dirtySinceLastSubmit) }
          type="submit"
          variant={ ButtonVariantType.action }
          block
          dataTest="portfolioMonitorContinueButtonButton"
        >
          <span className={ styles.buttonContent }>
            { isLoading ? <Spinner className={ portfolioStyles.spinner } /> : 'Continue' }
          </span>
        </Button>
      </div>
    </>
  );

  const submit = async ({ portfolioName }) => {
    const portfoliosNames = portfolioCollection.reduce(
        (acc, curr) => (curr.name !== selectedPortfolio.name ? [...acc, curr.name] : acc),
        [],
    );

    if (portfoliosNames.includes(portfolioName)) {
      return { portfolioName: 'A Portfolio with this name already exists' };
    }

    setPayload((prevState) => ({ ...prevState, name: portfolioName, priority: portfolioCollection.length + 1 }));
    return goNext();
  };

  return (
    <div className={ styles.formWrapper }>
      <div className={ styles.formArea }>
        <IconCategoriesEmpty />
        <div className={ styles.title }>Create a Portfolio</div>
        <div className={ styles.description }>
          Portfolios are the top level collection of lists of securities.
          Once you create a portfolio, you create a list.
          Within a list are the securities you wish to monitor.
        </div>
        <FinalForm
          className={ styles.form }
          name="namePortfolioForm"
          dataTest="namePortfolioForm"
          render={ renderFields }
          initialValues={ { portfolioName: payload?.name || '' } }
          onSubmit={ submit }
          validate={ validate }
        />
      </div>
    </div>
  );
};

export default NamePortfolioForm;
